<template>
    <div :id="'job--' + item.id"
         class="item pb-3 mb-5 border-bottom">

        <transition mode="out-in" name="slide">
            <div v-if="!isEdit"
                 class="row">
                <div class="col-12 mb-3">

                    <div class="row mb-3">
                        <h2 class="col-12 col-md-9">{{ element.headline }}</h2>
                        <h2 class="col-12 col-md-3 text-md-right">
                            <span :class="element.active ? 'badge-success' : 'badge-danger'"
                                  class="badge">{{
                                    element.active ? 'Aktiv' : 'Inaktiv'
                                }}</span>
                        </h2>
                    </div>

                    <div :id="'job-item-' + item.id"  v-if="showMore">
                        <div class="row mb-3">
                            <div class="col-12 col-md-6">
                                <div class="row">
                                    <h4 class="col-12 border-bottom">Wichtige Job Daten</h4>
                                    <p v-if="element.state"
                                       class="col-12"><b><i class="fad fa-map-pin"></i> Bundesland</b>:
                                        {{ element.state.name }}</p>

                                    <p v-if="element.type"
                                       class="col-12"><b><i class="fad fa-user-md"></i> Anstellungsart</b>: {{
                                            element.type.name
                                        }}</p>

                                    <p v-if="element.hours"
                                       class="col-12"><b><i class="fad fa-clock"></i> Wochenstunden</b>:
                                        {{ element.hours }}
                                    </p>

                                    <p v-if="element.salary"
                                       class="col-12"><b><i class="fad fa-euro-sign"></i> Monatsbruttogehalt</b>:
                                        {{ element.salary }}</p>
                                </div>
                            </div>

                            <div class="col-12 col-md-6">
                                <div class="row">
                                    <h4 class="col-12 border-bottom">Kontakt Informationen</h4>

                                    <p v-if="element.merchant.contact[0].name"
                                       class="col-12"><b><i class="fad fa-user"></i> Arbeitgeber</b>:
                                        {{ element.merchant.contact[0].name }}</p>

                                    <p v-if="element.merchant.contact[0].fax"
                                       class="col-12"><b><i class="fad fa-fax"></i> Fax</b>: {{
                                            element.merchant.contact[0].fax
                                        }}</p>

                                    <p v-if="element.merchant.contact[0].phone"
                                       class="col-12"><b><i class="fad fa-phone"></i> Tel.</b>:
                                        {{ element.merchant.contact[0].phone }}</p>

                                    <p v-if="element.merchant.contact[0].email"
                                       class="col-12"><b><i class="fad fa-envelope"></i> Email</b>:
                                        {{ element.merchant.contact[0].email }}</p>
                                </div>
                            </div>

                        </div>

                        <div class="row">
                            <h4 class="col-12 border-bottom">Stellenbeschreibung</h4>
                            <div v-if="element.description" class="col-12" v-html="element.description"></div>
                        </div>
                    </div>
                </div>

                <!--            Buttons -->

                <div class="col-3 mb-3">
                    <button class="btn btn-sm btn-info mt-3" @click="showMore = !showMore">
                        {{ showMore ? 'Weniger Anzeigen' : 'Mehr Anzeigen' }}
                    </button>
                </div>

                <div class="col-4 my-3 d-flex flex-row justify-content-center">
                    <span v-if="element.media && element.media[0]">
                        <a :href="element.media[0].url"
                           class="btn btn-sm btn-success"
                           target="_blank">
                            Herunterladen <i class="fas fa-download"></i>
                        </a>
                    </span>
                </div>

                <div class="col-5 mb-3">
                    <buttons :isLoading="isLoading" @delete="deleteItem(item.id)" @edit="isEdit = true"></buttons>
                </div>



                <div class="col-12">
                    <h3>Bewerbungen</h3>
                    <div class="table-responsiv">
                        <table class="table">
                            <thead>
                            <tr>
                                <th scope="col">#</th>
                                <th scope="col">Anhang</th>
                                <th scope="col">Name</th>
                                <th scope="col">Adresse</th>
                                <th scope="col">PLZ</th>
                                <th scope="col">Stadt</th>
                                <th scope="col">Land</th>
                                <th scope="col">Geburtsdatum</th>
                                <th scope="col">Telefonnummer</th>
                                <th scope="col">E-Mail</th>
                                <th scope="col">Nachricht</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="(applicant, index) in element.applications" class="application__row">
                                <th scope="row">{{ index + 1 }}</th>
                                <td><a v-if="applicant.media.length > 0" :href="mediaPath(applicant)" target="_blank" class="mb-0"><i
                                    class="fad fa-file-download"></i></a>
                                    <p v-else class="mb-0"> - </p></td>
                                <td><p v-if="applicant.name" class="mb-0">{{ applicant.name }}</p>
                                    <p v-else class="mb-0"> - </p></td>
                                <td><p v-if="applicant.address" class="mb-0 address">{{ applicant.address }}</p>
                                    <p v-else class="mb-0"> - </p></td>
                                <td><p v-if="applicant.zip" class="mb-0">{{ applicant.zip }}</p>
                                    <p v-else class="mb-0"> - </p></td>
                                <td><p v-if="applicant.city" class="mb-0">{{ applicant.city }}</p>
                                    <p v-else class="mb-0"> - </p></td>
                                <td><p v-if="applicant.country" class="mb-0">{{ applicant.country }}</p>
                                    <p v-else class="mb-0"> - </p></td>
                                <td><p v-if="applicant.birthdate" class="mb-0">{{ applicant.birthdate }}</p>
                                    <p v-else class="mb-0"> - </p></td>
                                <td><p v-if="applicant.phone" class="mb-0">{{ applicant.phone }}</p>
                                    <p v-else class="mb-0"> - </p></td>
                                <td><p v-if="applicant.email" class="mb-0">{{ applicant.email }}</p>
                                    <p v-else class="mb-0"> - </p></td>
                                <td><p v-if="applicant.message" class="mb-0">{{ applicant.message }}</p>
                                    <p v-else class="mb-0"> - </p></td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>

            <buero-form
                v-if="isEdit"
                :elementValues="this.element"
                :schema="schema"
                method="patch"
                url="/api/merchant/jobs"
                @cancel="cancelEdit"
                @updateItem="updateItem"></buero-form>
        </transition>

    </div>
</template>

<script>
import {Form} from './Form';

export default {
    name: 'Job',
    props: {
        item: Object,
        jobTypes: Array,
        stateOptions: Array,
    },

    data() {
        return {
            isEdit: false,
            element: this.item,
            errors: {},
            isLoading: false,
            schema: [],
            showMore: false,
        };
    },
    mounted() {
        this.schema = (new Form('Job bearbeiten', this.jobTypes, this.stateOptions)).schema();
    },

    methods: {
        mediaPath(applicant) {
            return applicant.media[0].url;
        },

        cancelEdit() {
            this.isEdit = false;
        },

        updateItem(payload) {
            this.element = payload;
            this.isEdit = false;
        },

        deleteItem(payload) {
            this.$swal({
                title: 'Sind Sie sicher?',
                text: 'Sie können dies nicht rückgängig machen!',
                showDenyButton: true,
                confirmButtonText: `Löschen`,
                denyButtonText: `Nicht löschen`,
            }).then((result) => {
                if (result.isConfirmed) {
                    this.isLoading = true;
                    axios.delete('/api/merchant/jobs/' + payload).then((response) => {
                        this.$swal({
                            icon: 'success',
                            title: response.data.message,
                        });
                        this.isLoading = false;
                        this.$emit('deleteItem', payload);
                    }).catch((error) => {
                        this.$swal({
                            icon: 'error',
                            title: 'Es ist ein Fehler aufgetreten',
                        });
                        this.isLoading = false;
                    });
                }
            });
        },
    },

    computed: {
        startDate() {
            return moment(this.item.visible_from).format('LL');
        },

        endDate() {
            if (this.item.visible_to) {
                return ' bis ' + moment(this.item.visible_to).format('LL');
            }
        },

        online() {
            let tmpDate = moment().format('YYYY-MM-DD');
            return moment(tmpDate).isBetween(this.element.visible_from, this.element.visible_to, null, '[]');
        },
    },
};

</script>

<style scoped>
.application__row td {
    min-width: 150px;
}

.application__row .address {
    min-width: 300px;
}

.table-responsiv {
    overflow-y: hidden;
}

</style>
